import { baseApi } from "./baseApi";
import * as API from "@utils/apiPath";
import type {
  SafetyListApiResponse,
  SafetyTableFilterParams,
} from "interface/safety";

const getFormattedParams = (params: SafetyTableFilterParams = {}) => {
  const formatted: Record<string, string | number> = {
    page: params.page ?? 1,
    limit: params.pageSize ?? 20,
  };
  if (params.type?.trim()) formatted.type = params.type.trim();
  if (params.status?.trim()) formatted.status = params.status.trim();
  if (params.user_id?.trim()) formatted.user_id = params.user_id.trim();
  if (params.booking_id?.trim()) formatted.booking_id = params.booking_id.trim();
  const bn = params.booking_number;
  if (bn != null) {
    const val = Array.isArray(bn) ? bn[0] : bn;
    if (typeof val === "string" && val.trim())
      formatted.booking_number = val.trim();
  }
  if (params.sortField) {
    formatted.sort = params.sortField;
    formatted.direction =
      params.sortOrder === "ascend" ? "asc" : "desc";
  }
  return formatted;
};

export const safetyApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getSafeties: builder.query<
      SafetyListApiResponse,
      SafetyTableFilterParams
    >({
      query: (params) => ({
        url: `/${API.GET_SAFETY}`,
        method: "GET",
        params: getFormattedParams(params),
      }),
      providesTags: ["Safety"],
    }),
    getSafetyPendingCount: builder.query<
      { statusCode: number; message: string; data: { count: number } },
      void
    >({
      query: () => ({
        url: `/${API.GET_SAFETY}/pending-count`,
        method: "GET",
      }),
      providesTags: ["Safety"],
    }),
    updateSafetyStatus: builder.mutation<
      { statusCode: number; message: string; data: unknown },
      { id: string; status: string }
    >({
      query: ({ id, status }) => ({
        url: `/${API.GET_SAFETY}/${id}`,
        method: "PATCH",
        body: { status },
      }),
      invalidatesTags: ["Safety"],
    }),
  }),
});

export const {
  useGetSafetiesQuery,
  useGetSafetyPendingCountQuery,
  useUpdateSafetyStatusMutation,
} = safetyApi;
